export default __webpack_public_path__ + "static/media/massup_xl3.0da8eb8b.png";